import clsx from 'clsx';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';

import {
  gradient,
  gradientDark,
  gradientLight,
  wrapper,
} from './PinnedCellGradient.css';

export const PinnedCellGradient = () => {
  const { isDarkMode } = useSiteTheme();

  return (
    <div className={wrapper}>
      <div
        className={clsx(gradient, isDarkMode ? gradientDark : gradientLight)}
      ></div>
    </div>
  );
};
